module.exports = __webpack_public_path__ + "static/media/D-Plate.f1944794.png";